




















import Vue, { PropType } from 'vue';
import { cloneDeep } from 'lodash';

import { Module } from '@/models/configurator/module';
import ModuleDetailCard from './ModuleDetailCard.vue';
import { searchItems } from '@/utils/helpers';

export default Vue.extend({
  name: 'ModuleList',

  components: { ModuleDetailCard },

  props: {
    modules: Array as PropType<Module[]>,

    search: String as PropType<string>,

    cloneIndex: Number as PropType<number>
  },

  data: () => ({
    moduleHeaders: [
      {
        text: '',
        sortable: false,
        align: 'start',
        width: '20px',
        value: 'data-table-filetype'
      },
      {
        text: 'Name',
        align: 'start',
        sortable: false,
        value: 'name',
        width: '150px',
        style: {
          'max-width': '100px'
        }
      },
      {
        text: 'Description',
        style: {
          'max-width': '100px'
        },
        value: 'description'
      }
    ],
    showMenu: false
  }),

  computed: {
    filterModules(): Module[] {
      return searchItems(this.modules, this.search);
    }
  },

  methods: {
    editModule(module: Module) {
      this.$emit('edit-module', cloneDeep(module));
    },
    deleteModule(id: number) {
      this.$emit('delete-module', id);
    },
    cloneModule(module: Module, index: number) {
      this.$emit('clone-module', { module, index });
    }
  }
});
